/**
 * Facets - Main entry point
 * Re-exports all filter components from the filters directory
 * This file exists for backwards compatibility with existing imports
 */

// Re-export everything from the filters module
export * from "./filter-index.js";

// Also import to ensure side effects (global event handlers) are executed
import "./filter-index.js";
